// Client feedback shown above the footer. SAMPLE = true shows a visible "sample" tag until
// the company supplies client-approved quotes; swap the entries below and set SAMPLE = false.
export const TESTIMONIALS_SAMPLE = true;

export const TESTIMONIALS = [
  {
    quote: "The ALTA sheet set came back organised exactly to our template — layers, notes and Table A blocks where our reviewers expect them. Redlines were closed in a single round.",
    name: "Principal Surveyor", org: "Title survey firm", region: "Florida, USA", service: "ALTA/NSPS Land Title Survey Drafting", slug: "alta-nsps-survey-drafting",
  },
  {
    quote: "We send PNEZD files and field sketches on Friday and have clean topo and boundary linework ready for review when the week starts. The QA notes that catch our own code mistakes are the real value.",
    name: "Survey Department Lead", org: "Civil engineering practice", region: "Ontario, Canada", service: "Topographic Survey Drafting", slug: "topographic-survey-drafting",
  },
  {
    quote: "Point cloud to Civil 3D surfaces and alignments without the usual back-and-forth. They ask the right questions before drafting instead of guessing.",
    name: "Project Surveyor", org: "Infrastructure consultancy", region: "Queensland, Australia", service: "Point Cloud to CAD", slug: "point-cloud-to-cad",
  },
];

// Site-wide key points, shown in the footer highlight block.
export const KEY_POINTS = [
  ["50+ services · 7 categories", "Every land surveying drafting type, A to G, with its own dedicated page."],
  ["Client-supplied survey data", "We draft; field surveying and professional certification stay with the licensed surveyor."],
  ["Your CAD standards", "Layers, blocks, text styles and title blocks matched to your template — or ours."],
  ["5-step quality review", "Independent check of linework, labels and values against your data before plot."],
  ["DWG · DXF · PDF · Civil 3D", "Deliverables in the formats your workflow needs, plus surfaces and alignments where relevant."],
  ["Quotation-based pricing", "Five engagement models, no invented rates, and a reference number for every submission."],
];
